import React, {useState, useEffect} from 'react'
import {FiUpload} from 'react-icons/fi';
import configBackend from '../../config-backend';

import './styles.css';

interface Props {
    onFileUploaded: (file: File) => void;
    selectedFile: File | undefined;
    currentUrl: string;
}

const DropzoneAudio: React.FC<Props> = ({onFileUploaded, selectedFile, currentUrl}) => {
    const [selectedFileUrl, setSelectedFilesUrl] = useState('');

    useEffect(() => {
        currentUrl && setSelectedFilesUrl(currentUrl);
    }, [currentUrl]);

    return (
        <div className="field">
            <label htmlFor="file-upload" className="custom-file-upload">
                Selecione o áudio da história <FiUpload/>
            </label>
            <input type="file" id="file-upload" accept=".mp3,.m4a"
                   onChange={(e) => {
                       if (e.target.files) {
                           onFileUploaded(e.target.files[0])
                       }
                   }}/>
            {
                (selectedFile)
                    ? (
                        <p>
                            {selectedFile.name}
                        </p>
                    ) : (selectedFileUrl && selectedFileUrl !== `${configBackend}/uploads/` && selectedFileUrl.includes(':3333/uploads')) && (
                    <p>
                        {selectedFileUrl.slice(selectedFileUrl.indexOf('-') + 1)}
                    </p>
                )
            }
        </div>
    );
}

export default DropzoneAudio;
